const CUR_YEAR = new Date().getFullYear();
export const YEARS = [
    String(CUR_YEAR - 2),
    String(CUR_YEAR - 1),
    String(CUR_YEAR),
];
